import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import moment from "moment";
import Select from "react-select";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#ffc107"
      : state.isFocused
        ? "rgba(255, 193, 7, 0.1)"
        : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": { backgroundColor: "#ffc107" },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({ display: "none" }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
};

export default function SpinWheel() {
  
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  console.log("tableData::: ", tableData);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [range, setRange] = React.useState(0);

  React.useEffect(() => {
    getBranch();
  }, []);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    name: Yup.string().required("required"),
    value: Yup.string().required("required"),
    chanceBase: Yup.number().required("required"),
    type: Yup.string().required("required"),
  });

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/spin-wheel/get-spin-wheel`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
    setRange(item.chanceBase);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const data = { ...value };
    console.log("data::: ", data);

    axios
      .patch(
        `${API_URL}/api/admin/spin-wheel/update-spin-wheel/${rowValue._id}`,
        data
      )
      .then((res) => {
        console.log("update :::", res.data);

        if (res.data.status) {
          setButtonLoader(false);
          socket.emit("spinWheelUpdate");
          successEdit(res.data.message);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setButtonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/admin/spin-wheel/add-spin-wheel`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.status) {
          setButtonLoader(false);
          socket.emit("spinWheelAdd");

          successAdd(result.data.message);
        }
      })
      .catch((err) => {
        setButtonLoader(false);
        console.log("handleSubmit err :::", err);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this spin wheel record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">{msg || "The spin wheel record has been successfully removed."}</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/spin-wheel/delete-spin-wheel/${e._id}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        if (res.data.status) {
          socket.emit("deleteRoomTier");
          successDeleted(res.data.message);
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The spin wheel record has been added successfully."}</p>
      </SweetAlert>
    );
  };

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The spin wheel record has been updated successfully."}</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div className="content p-3">
          <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 20px rgba(0,0,0,0.08)" }}>
            {/* Form Header */}
            <div className="card-header bg-white" style={{ borderRadius: "12px 12px 0 0", borderBottom: "1px solid #f0f0f0", padding: "18px 24px" }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div style={{ width: "40px", height: "40px", background: "#f5a623", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "14px" }}>
                    <i className="fas fa-dharmachakra" style={{ color: "#fff", fontSize: "18px" }}></i>
                  </div>
                  <div>
                    <h5 style={{ margin: 0, fontWeight: "700", color: "#2d3748" }}>
                      {openValue === 1 ? "Add Spin Wheel" : "Edit Spin Wheel"}
                    </h5>
                    <small style={{ color: "#999" }}>Fill in the details below</small>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  style={{ borderRadius: "8px", fontWeight: "600" }}
                  onClick={() => setShowPage(false)}
                >
                  ← Back to List
                </button>
              </div>
            </div>

            {/* Form Body */}
            <div className="card-body" style={{ padding: "28px 24px" }}>
              <Box sx={{ width: "100%" }}>
                <Formik
                  initialValues={{
                    name: rowValue ? rowValue?.name : "",
                    value: rowValue ? rowValue?.value : "",
                    chanceBase: rowValue ? rowValue?.chanceBase : "",
                    type: rowValue ? rowValue?.type : "",
                  }}
                  validationSchema={LoginSchema}
                  onSubmit={(values) => {
                    setButtonLoader(true);
                    if (openValue === 1) addNewTournament(values);
                    if (openValue === 2) updateTournament(values);
                  }}
                >
                  {({ touched, errors, values, setFieldValue }) => (
                    <Form>
                      {/* Row 1: Name + Value */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px" }}>
                              Name <span className="text-danger">*</span>
                            </label>
                            <Field
                              type="text"
                              name="name"
                              placeholder="Enter Name"
                              className={`form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                              style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                            />
                            <ErrorMessage component="div" name="name" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px" }}>
                              Value <span className="text-danger">*</span>
                            </label>
                            <Field
                              type="text"
                              name="value"
                              placeholder="Enter Value"
                              className={`form-control ${touched.value && errors.value ? "is-invalid" : ""}`}
                              style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                            />
                            <ErrorMessage component="div" name="value" className="invalid-feedback" />
                          </div>
                        </div>
                      </div>

                      {/* Row 2: Chance Base + Type */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px" }}>
                              Chance Base <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              step="any"
                              min="0"
                              max="100"
                              className="form-control"
                              placeholder="Enter value (0–100)"
                              value={range}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || val === "." || (parseFloat(val) >= 0 && parseFloat(val) <= 100)) {
                                  setRange(val);
                                  setFieldValue("chanceBase", val);
                                }
                              }}
                              style={{ borderRadius: "8px", border: "1.5px solid #e2e8f0", padding: "10px 14px", fontSize: "14px" }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label style={{ fontWeight: "600", color: "#4a5568", fontSize: "13px", marginBottom: "6px" }}>
                              Type <span className="text-danger">*</span>
                            </label>
                            <Select
                              name="type"
                              options={[
                                { value: "FreeSpin", label: "Free Spin" },
                                { value: "PriceSpin", label: "Price Spin" },
                              ]}
                              value={values.type ? { value: values.type, label: values.type === "FreeSpin" ? "Free Spin" : "Price Spin" } : null}
                              onChange={(selected) => setFieldValue("type", selected ? selected.value : "")}
                              placeholder="Select type..."
                              styles={filterSelectStyles}
                              menuPortalTarget={document.body}
                            />
                            {touched.type && errors.type && (
                              <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>{errors.type}</div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div style={{ display: "flex", gap: "12px", paddingTop: "16px", borderTop: "1px solid #f0f0f0", marginTop: "8px" }}>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          style={{ minWidth: "120px", borderRadius: "8px", fontWeight: "700", padding: "10px 20px" }}
                          disabled={buttonLoader}
                        >
                          {buttonLoader ? (
                            <><span className="spinner-border spinner-border-sm mr-2"></span>Saving...</>
                          ) : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ minWidth: "100px", borderRadius: "8px", fontWeight: "600", padding: "10px 20px" }}
                          onClick={() => setShowPage(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card " style={{ overflow: "scroll" }}>
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-6 mb-3 mb-md-0">
                  {/* Empty space to align Add button to the right */}
                </div>
                <div className="col-md-6 text-right">
                  {accessObject?.addRoomTier === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                        setRange(0);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add Wheel
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body">
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Chance</th>
                    <th>Value</th>
                    {(accessObject?.editRoomTier === true ||
                      accessObject?.deleteRoomTier === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getRoomTier === true ? (
                    <>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                .reverse()
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.name}</td>
                                      <td>{item.chanceBase}</td>
                                      <td>{item.value}</td>
                                      <td className="d-flex justify-content-evenly ">
                                        {accessObject?.editRoomTier ===
                                          true && (
                                            <EditIcon
                                              className="mr-3 courser"
                                              onClick={() =>
                                                clickEditButton(item)
                                              }
                                            />
                                          )}
                                        {accessObject?.deleteRoomTier ===
                                          true && (
                                            <>
                                              <ClearIcon
                                                className="courser text-danger"
                                                onClick={() =>
                                                  warningWithConfirmMessage(item)
                                                }
                                              />
                                            </>
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={6} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={14} className="p-3">
                        <h5 className="text-center mb-0">Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {accessObject?.getRoomTier === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
